import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
} from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT } from "../../../text_control";
import { SUSSESS } from "../../../text_control/success-msg";
import { _getStorage, _setStorage } from "../../../utils/local-storage";

@Component({
  selector: "app-modalsave-no-taxinvoice",
  templateUrl: "./modalsave-no-taxinvoice.component.html",
  styleUrls: ["./modalsave-no-taxinvoice.component.scss"],
})
export class ModalsaveNoTaxinvoiceComponent implements OnInit {
  email = "";
  datamodal = [];
  buyer_id: any;
  dataparam: any;
  tpno: any;
  remark: String = "";
  orderNo: String = "";
  label_text: any = {};
  receiptDate: String = "";

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  headerNewService: any;

  constructor(
    public alertController: AlertController,
    public modalCtrl: ModalController,
    public router: Router,
    public apiservice: ApiserviceService,
    public navParams: NavParams,
    public loadingController: LoadingController,
    private appService: AppService
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.label_text = TEXT;
    console.log(navParams.get("remark"));
    this.datamodal = navParams.get("data");
    this.tpno = navParams.get("tpno");
    this.buyer_id = navParams.get("buyer_id");
    this.email = navParams.get("email");
    this.remark = navParams.get("remark");
    this.orderNo = navParams.get("orderNo");
    this.headerNewService = navParams.get("newService");
    this.receiptDate = navParams.get("receipt_date");
  }

  ngOnInit() {}

  async validateEmail() {
    const alert = await this.alertController.create({
      cssClass: "resend-confirm-email",
      header: "รูปแบบ email ไม่ถูกต้อง",
      buttons: [
        {
          text: "OK",
          role: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  async confirmAlert() {
    console.log("data ABB =====: ", this.datamodal);
    let groupData = [];

    if (this.email != "") {
      const re =
        /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) return this.validateEmail();
    }

    for (const item of this.datamodal) {
      const req = {
        fulltax: {
          confirmcreate: "confirm",
          searchABB: {
            bu: this.userBu,
            userid: this.userID,
            loc: this.userLoc,
            userSource: this.userSource,
            receiptno: [item],
            receipt_date: this.receiptDate,
            tpno: this.tpno,
            type: "",
          },
          user_id: this.userID,
          buyer_id: this.buyer_id,
          doctype: "1",
          email: this.email,
          remark: this.remark,
          orderNo: this.orderNo,
        },
      };
      let header: any;
      if (this.headerNewService) {
        header = this.headerNewService;
      }
      await this.apiservice
        ._post(
          this.apiservice.apiUrl + this.apiservice.confirmCreate,
          req,
          header
        )
        .then((res) => {
          try {
            if (res.statusCode === 200) {
              groupData.push({
                status: true,
                message: "สำเร็จ",
                request: req,
                ...res.data[0].data,
              });
            } else {
              groupData.push({
                status: false,
                message: "ไม่สำเร็จ",
                request: req,
                receiptNo: item,
              });
            }
          } catch (error) {
            groupData.push({
              status: false,
              message: "ไม่สำเร็จ",
              request: req,
              receiptNo: item,
            });
          }
        });
      console.log("groupdata ======: ", groupData);
    }
    const alert = await this.alertController.create({
      cssClass: "my-confirm-alert",
      header: SUSSESS.send_email_etax,
    });

    await alert.present();
    setTimeout(() => {
      alert.dismiss(true);
      this.modalCtrl.dismiss({ dismissed: true });
      _setStorage(STORAGE.DATA_PREVIEW_NO__TAXINVOICE, groupData);
      this.router.navigate(["/preview-no-taxinvoice"], {
        queryParams: {
          noName: "no_tax",
          selectedIndex: "4",
          newService: "NEW_SERVICE",
        },
      });
    }, 5000);
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  dismiss() {
    this.modalCtrl.dismiss({ dismissed: true });
    this.appService.setActive(3);
  }
}
